var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { editProperty } from "../actions/uiActions";
import { showModal } from "../../Modals/actions/modalActions";
import { reorderProperty, addProperty } from "../actions/templateActions";
import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";
import { StateSelector } from "../../Review/components/StateSelector";
import { createSelector } from 'reselect';
import { Translate } from "../../I18N";
import FormConfigInput from "./FormConfigInput";
import { FormConfigSelect } from "./FormConfigSelect";
import FormConfigRelationship from "./FormConfigRelationship";
import FormConfigNested from "./FormConfigNested";
import FormConfigCommon from "./FormConfigCommon";
import FormConfigMultimedia from "./FormConfigMultimedia";
import { FormConfigDate } from "./FormConfigDate";
import Icons from "./Icons";
import { FormConfigNewRelationship } from "./FormConfigNewRelationship";

const isLabelDuplicated = (index, template, formState) => {
  const commonPropIndex = index + template.commonProperties.length;
  return (
    Boolean(formState.$form.errors[`properties.${index}.label.duplicated`]) ||
    Boolean(formState.$form.errors[`commonProperties.${commonPropIndex}.label.duplicated`]));

};

const isErrorOnThisField = (error, index, isCommonProperty, template) => {
  const commonPropIndex = index + template.commonProperties.length;
  const [errorRoot, errorIndex] = error.split('.');
  return errorRoot === 'commonProperties' ?
  errorIndex === commonPropIndex.toString() && isCommonProperty :
  errorIndex === index.toString() && !isCommonProperty;
};

class MetadataProperty extends Component {
  renderForm() {
    const { type, index } = this.props;
    let defaultInput = /*#__PURE__*/_jsx(FormConfigInput, { type: type, index: index });

    if (this.props.isCommonProperty) {
      return /*#__PURE__*/_jsx(FormConfigCommon, { index: index, type: type });
    }

    switch (type) {
      case 'relationship':
        defaultInput = /*#__PURE__*/_jsx(FormConfigRelationship, { index: index, type: type });
        break;

      case 'select':
      case 'multiselect':
        defaultInput = /*#__PURE__*/_jsx(FormConfigSelect, { index: index, type: type });
        break;

      case 'nested':
        defaultInput = /*#__PURE__*/_jsx(FormConfigNested, { index: index, type: type });
        break;

      case 'media':
      case 'image':
      case 'preview':
        defaultInput = /*#__PURE__*/
        _jsx(FormConfigMultimedia, {
          type: type,
          index: index,
          canSetStyle: type === 'image' || type === 'preview',
          canBeRequired: type !== 'preview' }
        );

        break;

      case 'geolocation':
      case 'link':
        defaultInput = /*#__PURE__*/_jsx(FormConfigInput, { type: type, index: index, canBeFilter: false });
        break;

      case 'date':
      case 'daterange':
      case 'multidate':
      case 'multidaterange':
        defaultInput = /*#__PURE__*/_jsx(FormConfigDate, { index: index, type: type });
        break;

      // relationships v2:
      case 'newRelationship':
        defaultInput = /*#__PURE__*/_jsx(FormConfigNewRelationship, { type: type, index: index });
        break;

      default:
        defaultInput = /*#__PURE__*/_jsx(FormConfigInput, { type: type, index: index });
        break;
    }

    return defaultInput;
  }

  render() {
    const {
      label,
      connectDragSource,
      isDragging,
      connectDropTarget,
      uiState,
      index,
      localID,
      inserting,
      hasErrors,
      submitFailed
    } = this.props;
    const { editingProperty } = uiState.toJS();

    let propertyClass = 'list-group-item';
    if (isDragging || inserting) {
      propertyClass += ' dragging';
    }

    if (hasErrors && submitFailed) {
      propertyClass += ' error';
    }

    const iconClass = Icons[this.props.type] || 'font';
    const beingEdited = editingProperty === localID;

    const property = /*#__PURE__*/
    _jsx("div", { className: propertyClass }, void 0, /*#__PURE__*/
    _jsx("span", { className: "property-name" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: this.props.isCommonProperty ? 'lock' : 'bars', fixedWidth: true }), /*#__PURE__*/
    _jsx(Icon, { icon: iconClass, fixedWidth: true }),
    label !== null ?
    label : /*#__PURE__*/

    _jsx(StateSelector
    // @ts-expect-error
    , { propertyLabel: createSelector(
        (state) =>
        state.template.data.properties[this.props.index] ?
        state.template.data.properties[this.props.index].label :
        '',
        (value) => value
      ) }, void 0,

    ({ propertyLabel }) => propertyLabel
    )

    ), /*#__PURE__*/
    _jsx("div", { className: "list-group-item-actions" }, void 0,
    this.props.isLabelDuplicated && /*#__PURE__*/
    _jsx("span", { className: "validation-error" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "exclamation-triangle" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Duplicated label")
    ),

    this.props.isRelationDuplicated && /*#__PURE__*/
    _jsx("span", { className: "validation-error" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "exclamation-triangle" }), /*#__PURE__*/
    _jsx(Translate, { translationKey: "relationship consistency warning" }, void 0, "Cannot use 'any entity or document' if another relationship of the same type is already with a specific entity."


    )
    ),

    !this.props.syncedTemplate && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn btn-default btn-xs property-edit",
      onClick: () => this.props.editProperty(beingEdited ? null : localID) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "pencil-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit")
    ),
    !this.props.isCommonProperty && /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn btn-danger btn-xs property-remove",
      onClick: () => this.props.removeProperty('RemovePropertyModal', index) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "trash-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete")
    )

    )

    )
    );


    if (this.props.isCommonProperty) {
      return /*#__PURE__*/(
        _jsx("li", {}, void 0,
        property, /*#__PURE__*/
        _jsx(ShowIf, { if: beingEdited && !isDragging }, void 0, /*#__PURE__*/
        _jsx("div", { className: `propery-form${editingProperty === localID ? ' expand' : ''}` }, void 0,
        this.renderForm()
        )
        )
        ));

    }

    return connectDropTarget( /*#__PURE__*/
      _jsx("li", {}, void 0,
      connectDragSource(property), /*#__PURE__*/
      _jsx(ShowIf, { if: beingEdited && !isDragging }, void 0, /*#__PURE__*/
      _jsx("div", { className: `propery-form${editingProperty === localID ? ' expand' : ''}` }, void 0,
      this.renderForm()
      )
      )
      )
    );
  }
}

MetadataProperty.defaultProps = {
  label: null,
  submitFailed: false,
  hasErrors: false,
  isLabelDuplicated: false,
  isRelationDuplicated: false,
  syncedTemplate: false
};
























const target = {
  hover(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    const item = monitor.getItem();
    if (props.localID === item.editingProperty) {
      props.editProperty(null);
    }
    if (typeof dragIndex === 'undefined') {
      item.inserting = true;
      item.index = 0;
      props.addProperty({ label: item.label, type: item.type, inserting: true }, 0);
      return;
    }

    if (dragIndex === hoverIndex) {
      return;
    }

    if (item.alreadyReordered) {
      item.alreadyReordered = false;
      return;
    }

    props.reorderProperty(dragIndex, hoverIndex);
    item.index = hoverIndex;
    item.alreadyReordered = true;
  }
};

const dropTarget = DropTarget(['METADATA_PROPERTY', 'METADATA_OPTION'], target, (connector) => ({
  connectDropTarget: connector.dropTarget()
}))(MetadataProperty);

const source = {
  beginDrag(props) {
    return {
      index: props.index,
      label: props.label,
      type: props.type,
      editingProperty: props.uiState.get('editingProperty')
    };
  },
  endDrag(props, monitor) {
    const item = monitor.getItem();
    props.editProperty(item.editingProperty);
  }
};

const dragSource = DragSource('METADATA_PROPERTY', source, (connector, monitor) => ({
  connectDragSource: connector.dragSource(),
  isDragging: monitor.isDragging()
}))(dropTarget);

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { removeProperty: showModal, reorderProperty, addProperty, editProperty },
    dispatch
  );
}

const mapStateToProps = ({ template }, ownProps) => ({
  uiState: template.uiState,
  hasErrors: Object.keys(template.formState.$form.errors || {}).reduce(
    (result, error) =>
    result ||
    isErrorOnThisField(error, ownProps.index, ownProps.isCommonProperty, template.data) &&
    template.formState.$form.errors[error],
    false
  ),
  isLabelDuplicated: isLabelDuplicated(ownProps.index, template.data, template.formState),
  isRelationDuplicated: Boolean(
    template.formState.$form.errors[`properties.${ownProps.index}.relationType.duplicated`]
  ),
  submitFailed: template.formState.$form.submitFailed
});

export { dragSource, dropTarget, MetadataProperty };

export default connect(mapStateToProps, mapDispatchToProps)(dragSource);